import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useClient } from "../context/ClientContext.tsx";

export default function CheckoutStatus() {
    const navigate = useNavigate();
    const { organization } = useClient();

    const [status, setStatus] = useState("checking");
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        if (!organization) return;

        const checkStatus = async () => {
            try {
                const response = await fetch(
                    `https://api.zippyq.app/subscription-status?orgId=${encodeURIComponent(
                        organization
                    )}`
                );

                const data = await response.json();

                if (data.active) {
                    setStatus("active");
                    navigate("/"); // or wherever the user should land
                    return;
                }

                // Not active yet — keep polling
                setAttempts((prev) => prev + 1);
            } catch (err) {
                console.error("Error checking subscription:", err);
            }
        };

        // Poll every 2 seconds, up to 30 attempts (~60 seconds)
        if (attempts < 30 && status !== "active") {
            const timer = setTimeout(checkStatus, 2000);
            return () => clearTimeout(timer);
        } else if (attempts >= 30) {
            setStatus("timeout");
        }
    }, [organization, attempts, status, navigate]);

    // UI states
    if (status === "checking") {
        return (
            <div style={{ padding: "2rem", textAlign: "center" }}>
                <h2>Processing your subscription…</h2>
                <p>This usually takes just a moment.</p>
            </div>
        );
    }

    if (status === "timeout") {
        return (
            <div style={{ padding: "2rem", textAlign: "center" }}>
                <h2>Still waiting for confirmation</h2>
                <p>
                    Your payment may still be processing. Please refresh this page or
                    contact support if this continues.
                </p>
            </div>
        );
    }

    return null;
}